export const API_ERROR = "Something went wrong try again!";
export const REQUIRED_FIELDS = "Required fields are missing";
export const UPPERCASE = new RegExp(/[A-Z]/);
export const LOWERCASE = new RegExp(/[a-z]/);
export const DIGITS = new RegExp(/\d/);
export const SPECIALCHAR = new RegExp(/[#?!@$%^&*-]/);
export const MINLENGTH = new RegExp(/.{8,}/);
